import { Link, useParams } from 'react-router-dom';
import cls from './PublicClientProject.module.scss';
import logo from './Logo.svg';
import moment from 'moment';
import { useQuery } from '@apollo/client';
import { QUERY_PUBLIC_CLIENT_PROJECT } from '../../../graphql/client';
import { Avatar, Button, ConfigProvider, Empty, Progress, theme } from 'antd';
import React from 'react';
import ImageUrl from '../../../helpers/ImageUrl';
import { Level } from '../../../components/Project/Level/Level';
import _ from 'lodash';
import {
    to_public_client_project_group,
    to_public_client_project_messages,
    to_public_client_project_trainings,
} from '../../../routes';
import { RightOutlined } from '@ant-design/icons';
import slugify from 'slugify';
import { Comment } from '../../Client/Comment/Comment';
import sila from './sila.svg'

export function PublicClientProject() {
    const { public_key } = useParams();

    const [good, setGood] = React.useState('Хорошо');

    const query = useQuery(QUERY_PUBLIC_CLIENT_PROJECT, {
        variables: {
            public_key: public_key,
            messages_sort: ['createdAt:DESC'],
            messages_pagination: {
                limit: 1,
            },
        },
    });

    // console.log(query.error.message);
    // console.log(query.data?.publicClientProject);

    if (query.error?.message === 'Not found') {
        return (
            <div className={cls.body}>
                <div className={cls.wrapper}>
                    <div className={cls.block}>
                        <h3>Страница не найдена</h3>
                        <span>Возможно ошибка в ссылке</span>
                        <span>Обратитесь за помощью к администратору</span>
                        <Button size={'large'} onClick={() => setGood('😊️️')}>
                            {good}
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    const mass = _.reduce(
        query.data?.publicClientProject?.project?.experiences,
        (sum, item) => {
            // Проверяем, что list существует и это строка
            if (typeof item.list === 'string' && item.list.trim() !== '') {
                // Разделяем по \n и прибавляем количество получившихся элементов
                return sum + item.list.split('\n').length;
            }
            return sum;
        },
        0,
    );

    const color = query.data?.publicClientProject?.project?.color || '#2D68C4';

    const lastMessage = query.data?.publicClientProject?.messages[0] || undefined;
    const lastTraining = query.data?.publicClientProject?.trainings[0] || undefined;

    return (
        <div
            className={cls.body}
            style={{
                backgroundColor: color,
                backgroundImage: `url(${ImageUrl(query.data?.publicClientProject?.project?.cover?.url)})`,
            }}
        >
            <ConfigProvider
                theme={{
                    algorithm: theme.defaultAlgorithm,
                    token: {
                        colorPrimary: color,
                        colorLink: color,
                    },
                }}
            >
                <div className={cls.wrapper}>
                    <div className={cls.header}>
                        {query.data?.publicClientProject?.project?.logo && (
                            <img
                                className={cls.logo}
                                src={ImageUrl(query.data?.publicClientProject?.project?.logo?.url)}
                                alt={query.data?.publicClientProject?.project?.name}
                            />
                        )}
                        <img src={logo} className={cls.logo} alt={'Logo Sila Skilla'} />
                    </div>

                    <div className={cls.grid}>
                        <div className={cls.block}>
                            <Avatar
                                size={64}
                                src={
                                    query.data?.publicClientProject?.avatar &&
                                    ImageUrl(query.data?.publicClientProject?.avatar?.url)
                                }
                                style={
                                    !query.data?.publicClientProject?.avatar && {
                                        backgroundColor: query.data?.publicClientProject?.color,
                                    }
                                }
                            >
                                {query.data?.publicClientProject?.firstName.charAt(0)}
                                {query.data?.publicClientProject?.lastName.charAt(0)}
                            </Avatar>
                            <h3>
                                <b>
                                    {query.data?.publicClientProject?.firstName}{' '}
                                    {query.data?.publicClientProject?.lastName}
                                </b>
                            </h3>
                            {query.data?.publicClientProject?.birthDate && (
                                <span>
                                    {moment().diff(moment(query.data?.publicClientProject?.birthDate), 'years')} лет
                                </span>
                            )}
                        </div>
                        {query.data?.publicClientProject?.project?.levels?.length > 0 && (
                            <div className={cls.block}>
                                <Level
                                    color={query.data?.publicClientProject?.project?.color}
                                    value={query.data?.publicClientProject?.projectData?.length || 0}
                                    mass={mass}
                                    levels={query.data?.publicClientProject?.project?.levels}
                                />
                            </div>
                        )}
                        {query.data?.publicClientProject?.bonus > 0 && (
                            <div className={cls.block}>
                                <img src={sila} alt={'Sila Logo'} />
                                <h2>{query.data?.publicClientProject?.bonus}</h2>
                            </div>
                        )}
                        {query.data?.publicClientProject?.schoolUrl && (
                            <div className={cls.block}>
                                <a
                                    className={cls.header}
                                    href={query.data?.publicClientProject?.schoolUrl}
                                    target={'_blank'}
                                    rel={'noreferrer'}
                                >
                                    <div>Учеба</div>
                                    <Button type={'link'} icon={<RightOutlined />} />
                                </a>
                                    <a
                                        className={cls.url}
                                        href={query.data?.publicClientProject?.schoolUrl}
                                        target={'_blank'}
                                        rel={'noreferrer'}
                                        style={{color: query.data?.publicClientProject?.project?.color}}
                                    >
                                        {query.data?.publicClientProject?.schoolUrl}
                                    </a>
                            </div>
                        )}
                    </div>

                    <div className={cls.block}>
                        <Link to={to_public_client_project_messages(public_key)} className={cls.header}>
                            <div>Комментарии</div>
                            <Button type={'link'} icon={<RightOutlined />} />
                        </Link>
                        {lastMessage ? (
                            <Comment
                                firstName={lastMessage.author.firstName}
                                lastName={lastMessage.author.lastName}
                                color={lastMessage.author.color}
                                url={lastMessage.author.avatar?.url}
                                createdAt={lastMessage.createdAt}
                                message={lastMessage.message}
                            />
                        ) : (
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                        )}
                    </div>

                    <div className={cls.grid}>
                        {_.map(query.data?.publicClientProject?.project?.experiences, (group, index) => {
                            const list = group.list.trim().split('\n');
                            const value = _.reduce(
                                query.data?.publicClientProject?.projectData,
                                (sum, item) => {
                                    // если этот навык есть у пользователя, добавляем 1 балл
                                    if (list.includes(item)) {
                                        return sum + 1;
                                    }
                                    return sum;
                                },
                                0,
                            );
                            const percent = (value / list.length) * 100;
                            const slug = slugify(group.name, { lower: true });

                            return (
                                <div key={`item${index}`} className={cls.block}>
                                    <Link to={to_public_client_project_group(public_key, slug)} className={cls.header}>
                                        <div>{group.name}</div>
                                        <Button type={'link'} icon={<RightOutlined />} />
                                    </Link>
                                    <Progress percent={percent} showInfo={false} strokeColor={color} />
                                </div>
                            );
                        })}
                    </div>

                    <div className={cls.block}>
                        <Link to={to_public_client_project_trainings(public_key)} className={cls.header}>
                            <div>Занятия</div>
                            <Button type={'link'} icon={<RightOutlined />} />
                        </Link>
                        {lastTraining ? (
                            <>
                                <span>{lastTraining.name}</span>
                                {lastTraining.author && (
                                    <>
                                        <Avatar
                                            size={64}
                                            src={lastTraining.author.avatar && ImageUrl(lastTraining.author.avatar.url)}
                                            style={
                                                !lastTraining.author.avatar && {
                                                    backgroundColor: lastTraining.author.color,
                                                }
                                            }
                                        >
                                            {lastTraining.author.firstName.charAt(0)}
                                            {lastTraining.author.lastName.charAt(0)}
                                        </Avatar>
                                        <h3>
                                            {lastTraining.author.firstName} {lastTraining.author.lastName}
                                        </h3>
                                    </>
                                )}
                                <span>{moment(lastTraining.startDate).format('DD MMMM YYYY')}</span>
                            </>
                        ) : (
                            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                        )}
                    </div>

                    <div className={cls.divider} />

                    <div className={cls.footer}>
                        {_.map(query.data?.publicClientProject?.project?.links, (link, index) => (
                            <a key={`link${index}`} href={link.url} target={'_blank'} rel="noreferrer">
                                {link.name}
                            </a>
                        ))}
                        <span>© {moment().year()}</span>
                    </div>
                </div>
            </ConfigProvider>
        </div>
    );
}
